/*
 * @Author: 汪永康 wangyongkang@yxj.org.cn
 * @Date: 2024-09-09 10:44:08
 * @LastEditors: 汪永康 wangyongkang@yxj.org.cn
 * @LastEditTime: 2024-11-20 16:33:56
 * @FilePath: \h5-lcjc-formula\src\utils\category\Onco.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
/** 创伤医学 */
/** 肿瘤学 */

/** 对应的标题 */
const categoryMap = {
  Zubrod: '体力状况（Zubrod）',
  Karnofsky: '体力状况（Karnofsky）',
  OvarianCancer_Figo: '卵巢癌Figo分期',
  LungCancer_TNM: '肺癌TNM分期（第八版）',
  Breast_Cancer_TNM: '乳腺癌TNM分期',
  EortcQLQC30: 'EORTC QLQ-C30量表',
  VaginalCancer_TNM: '阴道癌TNM分期',
  BladderTumor_TNM: '膀胱肿瘤TNM分期',
  VulvarCancer_TNM: '外阴癌TNM分期',
  VulvarCancer_FIGO: '外阴癌FIGO分期',
  H_nHLymphoma: '霍奇金与非霍奇金淋巴瘤分期',
  IntrahepaticBileDuct_TNM: '肝内胆管癌TNM分期',
  AbdominalTumorRelatedMarkers: '腹腔肿瘤相关标志物',
  BCLC: '巴塞罗那（BCLC）肝癌分期',
  PenileCancer_TNM: '阴茎癌TNM分期',
  PerformanceScore_KPS: '肿瘤患者体能状态评分（KPS法）',
  VaginalCancer_FIGO: '阴道癌FIGO分期',
  Chemotherapy_WHO: '化疗后骨髓抑制分度标准（WHO）',
  ProstateCancer_Gleason: '前列腺癌Gleason评分',
  SolidTumor: '实体瘤的疗效评价标准',
  SIN_VIN: '外阴鳞状上皮内瘤变（VIN）分型',
  BreastSarcoma_TNM: '乳腺肉瘤TNM分期',
  BreastLobeTumor: '乳腺叶状肿瘤TNM分期',
  BreastCancerRAndT: '乳腺癌术后复发风险及治疗方案',
  Bismuth_Corlette: 'Bismuth-Corlette分型',
  PrimaryLiverCancer: '原发性肝癌TNM分期',
  PelvisAndUretertumors_TNM: '肾盂和输尿管肿瘤TNM分期',
  TNMHilarCholangiocarcinoma: '肝内胆管癌的TNM分期',
  RMII: '恶性肿瘤风险指数I（RMI I）评分',
  Pancreatic_neuroendocrine_tumors: '胰腺神经内分泌肿瘤TNM分期',
  Postpubertal_sex_cord: '睾丸青春期后生殖细胞肿瘤及恶性性索间质肿瘤TNM分期',
  Oropharyngeal_acancer: '口咽（P16-）和喉咽癌TNM分期',
  Ovarian_and_fallopian_tube_tumors_and_primary_peritoneal_cancer: '卵巢、输卵管肿瘤和原发性腹膜癌TNM分期',
  Cervix_carcinoma: '宫颈癌TNM分期',
  Retroperitoneal_soft_tissue_sarcoma: '腹膜后软组织肉瘤TNM分期',
  Merkel_cell_tumor: 'Merkel细胞瘤TNM分期',
  Neuroendocrine_tumors_of_duodenum_and_ampulla_of_Vater: '十二指肠和Vater壶腹神经内分泌肿瘤TNM分期',
  Localized_Prostate_Cancer_Risk_Grading: '前列腺癌临床风险分层',
  Gastric_neuroendocrine_tumor: '胃神经内分泌肿瘤TNM分期',
  Medullary_thyroid_carcinoma: '甲状腺髓样癌TNM分期',
  Jejunoileal_neuroendocrine_tumor: '空肠、回肠神经内分泌肿瘤TNM分期',
  HPV_associated_oropharyngeal_cancer: 'HPV相关性(P16+)口咽癌TNM分期',
  Gestational_trophoblastic_tumor: '妊娠滋养细胞肿瘤TNM分期',
  nasal_cavity_and_paranasal_sinus_tumors: '鼻腔与鼻窦肿瘤TNM分期',
  gallbladder_carcinoma: '胆囊癌TNM分期',
  Major_salivary_gland_tumor: '大唾液腺肿瘤TNM分期',
  Anal_neoplasm: '肛门肿瘤TNM分期',
  Testicular_neoplasm: '睾丸肿瘤TNM分期',
  Colorectal_cancer: '结直肠癌组织学Broders分级',
  Endometrial_cancer: '子宫内膜癌FIGO分期',
  Soft_tissue_sarcoma_of_abdominal_and_thoracic_visceral_organs: '腹部和胸腔内脏器官软组织肉瘤TNM分期',
  Laryngeal_neoplasm: '喉部肿瘤TNM分期',
  Appendiceal_tumor: '阑尾肿瘤TNM分期',
  Kidney_cancer: '肾癌TNM分期',
  Syringomyelia: '脊髓空洞症Barnett分型',
  Phyllodes_tumor_of_breast: '乳腺叶状肿瘤TNM分期',
  Thymic_tumor: '胸腺肿瘤TNM分期',
  Eyelid_carcinoma: '眼睑癌TNM分期',
  Corpus_uteri_tumor: '子宫体肿瘤TNM分期',
  Small_intestinal_neoplasm: '小肠肿瘤TNM分期',
  Multiple_myeloma: '多发性骨髓瘤Durie-Salmon分期',
  Gastrointestinal_stromal_tumor: '胃肠道间质瘤TNM分期',
  Cutaneous_melanoma: '皮肤黑色素瘤TNM分期',
  Appendiceal_neuroendocrine_tumor: '阑尾神经内分泌肿瘤TNM分期',
  Retinoblastoma: '视网膜母细胞瘤TNM分期',
  Fallopian_tube_neoplasms: '输卵管肿瘤TNM分期',
  Ampullary_carcinoma_of_Vater: 'Vater壶腹癌TNM分期',
  Orbital_sarcoma: '眼眶肉瘤TNM分期',
  Adenocarcinoma_lacrimal: '泪腺癌TNM分期',
  Malignant_melanoma_of_head_and_neck: '头颈部的恶性黑色素瘤TNM分期',
  Prostate_cancer: '前列腺癌Gleason分级',
  GLeason_Score: '前列腺癌Gleason评分',
  Conjunctival_melanoma: '结膜黑色素瘤TNM分期',
  Conjunctival_carcinoma: '结膜癌TNM分期以及组织学分级',
  Parathyroid_carcinoma: '甲状旁腺癌TNM分期',
  Gallbladder_sarcoma: '胆囊肉瘤TNM分期',
  FAB_classification_of_myelodysplastic_syndrome: '骨髓增生异常综合征（MDS）FAB分型',
  Cancer_of_anal_canal: '肛管癌TNM分期',
  Soft_tissue_sarcoma: '软组织肉瘤TNM分期',
  Anatomical_staging_of_trophoblastic_tumor: '滋养细胞肿瘤解剖学分期',
  UCLA_Comprehensive_Staging_System_for_Renal_Cancer: '肾癌的UCLA分级系统',
  Fuhrman: '肾癌Fuhrman分级',
  MIPI_c: '套细胞淋巴瘤国际预后指数（MIPI-c）',
  Mantle_cell_lymphoma: '套细胞淋巴瘤国际预后指数（MIPI）',
  Modified_Prognostic_Scoring_System_for_Trophoblastic_Tumor: '滋养细胞肿瘤改良预后评分系统（FIGO）',
  Risk_grading_after_resection_of_gastrointestinal_stromal_tumors: '胃肠道间质瘤GIST切除术后风险分级',
  Carboplatin_Dose: '卡铂剂量',
  Grading_methods_for_immature_teratoma: '未成熟畸胎瘤的分级方法',
  Carbohydrate_Antigen_seven_four: '癌抗原72-4（CA72-4）',
  Homocysteine: '半胱氨酸',
  Calvert: '卡铂 AUC 剂量',
  Squamous_Cell_Carcinoma: '状上皮细胞癌抗原(SCCA)',
  Absolute_Eosinophil_Count: '嗜酸性粒细胞绝对计数',
  Eosinophil_Cationic_Protein: '嗜酸性粒细胞阳离子蛋白（ECP）',
  Basophil_Absolute_Count: '嗜碱性粒细胞绝对计数',
  Basophils: '嗜碱性粒细胞',
  Cancer_Antigen_125: '癌抗原125（CA125）',
  a1_acid_glycoprotein: 'α1-酸性糖蛋白',
  Kappa_Light_Chain: 'κ轻链',
  Carcinoembryonic_Antigen: '癌胚抗原',
  Cancer_Antigen_15_3: '癌抗原15-3（CA15-3）',
  Carbohydrate_Antigen_19_9: '癌抗原19-9（CA19-9）',
  Neuron_Specific_Enolase: '神经元特异性烯醇化酶（NSE）',
  Growth_Differentiation_Factor_15: '生长分化因子15（GDF-15）',
  Acid_Phosphatase: '酸性磷酸酶（ACP）',
  Aspartic_Acid: '天冬氨酸（Asp）',
  Asparagine: '天冬酰胺（Asn）',
  Ferritin: '铁蛋白',
  Ceruloplasmin: '铜蓝蛋白（CP）',
  Pro_gastrin_releasing_peptide: '胃泌素释放肽前体（ProGRP）',
  Cytokeratin_19_Fragment: '细胞角蛋白19片段（CYFRA 21-1）'
}
/** 对应的描述 */
const categoryDescMap = {
  Zubrod: '生活质量等级，ECOG/WHO 分级',
  Karnofsky: '癌症患者生活质量',
  OvarianCancer_Figo: '国际妇产科联盟分期',
  LungCancer_TNM: '评估肺癌患者病情进展',
  Breast_Cancer_TNM: '评估患者乳腺癌进展',
  EortcQLQC30: '评价癌症患者生活质量',
  VaginalCancer_TNM: '',
  BladderTumor_TNM: '',
  VulvarCancer_TNM: '评估外阴癌患者病情进展',
  VulvarCancer_FIGO: '评估外阴癌患者病情进展',
  H_nHLymphoma: 'AnnArbor分期标准',
  IntrahepaticBileDuct_TNM: '评估肝内胆管癌疾病进展',
  AbdominalTumorRelatedMarkers: '',
  BCLC: '',
  PenileCancer_TNM: '评估阴茎癌患者病情进展',
  PerformanceScore_ZPS: '评价肿瘤患者生活质量',
  PerformanceScore_KPS: '评价肿瘤患者生活质量',
  VaginalCancer_FIGO: '评估阴道癌患者病情进展',
  Chemotherapy_WHO: '抗癌药物急性及亚急性毒性反应分度标准',
  ProstateCancer_Gleason: '前列腺腺癌分级分组',
  SolidTumor: '评估肿瘤的治疗效果（Recist1.1版本）',
  SIN_VIN: '根据肉眼及镜下表现评估VIN类型',
  BreastSarcoma_TNM: '评估乳腺肉瘤患者病情进展',
  BreastLobeTumor: '评估乳腺叶状肿瘤患者病情进展',
  BreastCancerRAndT: '',
  Bismuth_Corlette: '肝门部胆管癌分型',
  PrimaryLiverCancer: '评估肝癌患者病情进展',
  PelvisAndUretertumors_TNM: '评估肾盂和输尿管肿瘤患者病情进展',
  TNMHilarCholangiocarcinoma: '评估肝门胆管癌病情进展',
  RMII: '卵巢癌风险指数',
  Prostate_cancer: '前列腺癌组织学分级',
  GLeason_Score: '前列腺癌恶性程度评估',
  UCLA_Comprehensive_Staging_System_for_Renal_Cancer: '肾癌术后预后评估',
  Fuhrman: '基于肾癌细胞核的明显程度',
  MIPI_c: 'MIPI结合Ki-67指数',
  Mantle_cell_lymphoma: '评估套细胞淋巴瘤预后'
}
export default {
  categoryMap,
  categoryDescMap
}



// WEBPACK FOOTER //
// ./src/utils/category/Onco.js